/**
 * @generated SignedSource<<0775e3a8b296166208bb23c3ba5ac942>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersRecruitIncentiveTypeChoices = "CA" | "EX" | "PT" | "%future added value";
export type UpdateRecruitDetailsInput = {
  clientMutationId?: string | null;
  description?: string | null;
  goal?: number | null;
  incentive?: string | null;
  incentivePoints?: number | null;
  incentiveType?: string | null;
  name?: string | null;
  recruitId: string;
  remindersEnabled?: boolean | null;
  settings?: any | null;
};
export type RecruitForm_UpdateRecruitDetails_Mutation$variables = {
  input: UpdateRecruitDetailsInput;
};
export type RecruitForm_UpdateRecruitDetails_Mutation$data = {
  readonly updateRecruitDetails: {
    readonly recruit: {
      readonly description: string | null;
      readonly goal: number | null;
      readonly id: string;
      readonly incentive: string | null;
      readonly incentivePoints: number | null;
      readonly incentiveType: ScreenersRecruitIncentiveTypeChoices | null;
      readonly name: string | null;
      readonly remindersEnabled: boolean;
    } | null;
  } | null;
};
export type RecruitForm_UpdateRecruitDetails_Mutation = {
  response: RecruitForm_UpdateRecruitDetails_Mutation$data;
  variables: RecruitForm_UpdateRecruitDetails_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateRecruitDetailsPayload",
    "kind": "LinkedField",
    "name": "updateRecruitDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitNode",
        "kind": "LinkedField",
        "name": "recruit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "goal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incentive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incentivePoints",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incentiveType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remindersEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitForm_UpdateRecruitDetails_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitForm_UpdateRecruitDetails_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "03b56a5e1308d45799dde9056384a17d",
    "id": null,
    "metadata": {},
    "name": "RecruitForm_UpdateRecruitDetails_Mutation",
    "operationKind": "mutation",
    "text": "mutation RecruitForm_UpdateRecruitDetails_Mutation(\n  $input: UpdateRecruitDetailsInput!\n) {\n  updateRecruitDetails(input: $input) {\n    recruit {\n      id\n      name\n      description\n      goal\n      incentive\n      incentivePoints\n      incentiveType\n      remindersEnabled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da40b413d502834aa68c626e6f01c483";

export default node;
